import { render, staticRenderFns } from "./UploadTeamLogo.vue?vue&type=template&id=52dc3a2a&"
import script from "./UploadTeamLogo.vue?vue&type=script&lang=js&"
export * from "./UploadTeamLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports